import { RouterProvider } from 'react-router-dom';
import RouteConfig from './routes/index';
import React from 'react';


const App = () => {  
  return (<RouterProvider router={RouteConfig} />);
};

export default App;
